import { addressDrawerApplyButtonStyles } from "@insite/content-library/Widgets/Header/AddressDrawerApplyButton";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

addressDrawerApplyButtonStyles.button = {
    css: css`
        background: ${WhitecapColors.yellow2} !important;
        border: 2px solid ${WhitecapColors.yellow2} !important;
        &:disabled {
            background: ${WhitecapColors.gray3} !important;
            border-color: ${WhitecapColors.gray3} !important;
            color: ${WhitecapColors.white} !important;
        }
    `,
};
